import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import HrHeader from '../HrHeader';
import HrSideBar from '../HrSideBar';
import Table from '../../../../src/components/tableComponents/Table';
import Dropdown from '../../../components/dropdown/DropDown';
import { fetchCollaboration, deleteCollaboration, updateCollaboration } from '../../../redux/actions/action';
import AddCollaborationForm from '../Collaboration/AddCollaborationForm';
import ViewCollaboration from './ViewCollaboration';
import EditCollaboration from './EditCollaboration';
import DeleteCollaboration from './DeleteCollaboration';
import ViewDescription from './ViewDescription';


const Collaborationbackendd = () => {
  const [showCollaborationForm, setShowCollaborationForm] = useState(false);
  const [showViewCollaboration, setShowViewCollaboration] = useState(false);
  const [showEditCollaboration, setShowEditCollaboration] = useState(false);
  const [showDeleteCollaboration, setShowDeleteCollaboration] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [tableData, setTableData] = useState([]);

  const dispatch = useDispatch();
  const { collaborations, loading, error } = useSelector((state) => state.collaboration || {});

  useEffect(() => {
    const loadCollaboration = async () => {
      try {
        await dispatch(fetchCollaboration());
      } catch (error) {
        console.error("Error fetching collaborations:", error);
      }
    };
    loadCollaboration();
  }, [dispatch]);

  useEffect(() => {
    if (collaborations && Array.isArray(collaborations)) {
      const formattedData = collaborations.map((collaboration, index) => ({
        ...collaboration,
        slno: index + 1,
      }));
      setTableData(formattedData);
    }
  }, [collaborations]);

  const openDescription = (description) => {
    setSelectedDescription(description);
    setIsModalOpen(true);
  };

  const openCollaborationForm = () => setShowCollaborationForm(true);
  const closeCollaborationForm = () => setShowCollaborationForm(false);

  const openView = (event) => {
    setSelectedEvent(event);
    setShowViewCollaboration(true);
  };

  const openEdit = (event) => {
    setSelectedEvent(event);
    setShowEditCollaboration(true);
  };

  const openDelete = (event) => {
    setSelectedEvent(event);
    setShowDeleteCollaboration(true);
  };

  const handleSave = async () => {
    try {
      await dispatch(fetchCollaboration());
      closeCollaborationForm();
    } catch (error) {
      console.error("Error saving collaboration:", error);
    }
  };

  const handleDeleteRow = async (projectNo) => {
    try {
      await dispatch(deleteCollaboration(projectNo));
      await dispatch(fetchCollaboration());
    } catch (error) {
      console.error("Error deleting collaboration:", error);
    }
  };

  const handleUpdateCollaboration = async (updatedData) => {
    try {
      await dispatch(updateCollaboration(updatedData));
      await dispatch(fetchCollaboration());
    } catch (error) {
      console.error("Error updating collaboration:", error);
    }
  };

  const columns = useMemo(
  () => [
    { Header: 'S.No', accessor: 'slno' },
    { 
      Header: 'Project Name', 
      accessor: 'projectName',
      Cell: ({ value }) => (
        <span className="block max-w-[250px] break-words whitespace-normal">
          {value}
        </span>
      )
    },
    { 
      Header: 'Project sponsor', 
      accessor: 'organizationName',
      Cell: ({ value }) => (
        <span className="block max-w-[200px] break-words whitespace-normal">
          {value}
        </span>
      )
    },
    { Header: 'Category', accessor: 'category' },
    { Header: 'Research Area', accessor: 'researchArea' },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      Cell: ({ value }) => value ? new Date(value).toLocaleDateString() : '-'
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      Cell: ({ value }) => value ? new Date(value).toLocaleDateString() : '-'
    },
    { Header: 'Team Size', accessor: 'teamSize' },
    {
      Header: 'Action',
      accessor: 'actions',
      Cell: ({ row }) => (
        <Dropdown
          options={['View', 'Edit', 'Delete', 'Description']}
          onSelect={(option) => {
            if (option === 'View') openView(row.original);
            if (option === 'Edit') openEdit(row.original);
            if (option === 'Delete') openDelete(row.original);
            if (option === 'Description') openDescription(row.original.projectDescription);
          }}
        />
      )
    }
  ],
  []
);


  const renderContent = () => {
    if (loading) {
      return <div className="text-white text-center p-4">Loading...</div>;
    }

    if (error) {
      return <div className="text-white text-center p-4 text-red-500">Error: {error}</div>;
    }

    return (
      <div className="text-white">
        <Table
          columns={columns}
          data={tableData}
          heading="Collaboration List"
          className="w-full"
        />
      </div>
    );
  };

  return (
    <div className="flex flex-row w-full h-screen bg-[#090119] overflow-hidden">
      <HrHeader dashboardName="Collaboration Management" />
      <HrSideBar />
      <div className="md:flex-1 md:ml-8 px-4 pt-24 pl-60">
        <div className="text-white">
          <div className="mb-2 pt-4 flex justify-end items-center pr-8">
            <button
              onClick={openCollaborationForm}
              className="bg-color hover:bg-blue-700 text-white font-bold py-2 px-4 rounded lg:w-[60px] lg:mr-[-30px] lg:absolute top-[130px] xl:w-[150px] xl:mt-2 xl:mr-10"
            >
              Add
            </button>
          </div>
          {renderContent()}
        </div>
      </div>

      {showCollaborationForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto">
          <AddCollaborationForm onClose={closeCollaborationForm} onSave={handleSave} />
        </div>
      )}

      {isModalOpen && (
        <ViewDescription onClose={() => setIsModalOpen(false)} title="Project Description">
          <p>{selectedDescription}</p>
        </ViewDescription>
      )}

      {showViewCollaboration && (
        <ViewCollaboration event={selectedEvent} onClose={() => setShowViewCollaboration(false)} />
      )}

      {showEditCollaboration && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <EditCollaboration
            event={selectedEvent}
            onClose={() => setShowEditCollaboration(false)}
            onUpdate={handleUpdateCollaboration}
          />
        </div>
      )}

      {showDeleteCollaboration && (
        <DeleteCollaboration
          event={selectedEvent}
          onClose={() => setShowDeleteCollaboration(false)}
          onDelete={async () => {
            await handleDeleteRow(selectedEvent.projectNo);
            setShowDeleteCollaboration(false);
          }}
        />
      )}
    </div>
  );
};

export default Collaborationbackendd;
